import React from 'react';
import { Icon } from 'antd';
import cn from 'classnames';
import styles from './SelectedOption.module.scss';

const SelectedOption = ({ value, text, onRemove, dateFilter = false }) => {
  return (
    <div
      className={cn(styles.root, {
        [styles.filter]: !dateFilter,
        [styles.dateFilter]: dateFilter,
      })}
    >
      {text}
      {typeof onRemove === 'function' && (
        <Icon
          className={styles.icon}
          type="close"
          onClick={() => onRemove(value)}
        />
      )}
    </div>
  );
};

export default SelectedOption;
